import { defineLpController } from "../controllers/component-manager";
class UnsafeHtmlElement extends HTMLElement {
    connectedCallback() {
        const template = document.createElement("template");
        template.innerHTML = this.textContent || "";
        this.replaceWith(template.content);
    }
}
defineLpController("lp-unsafe-html", UnsafeHtmlElement, "UnsafeHtml");
